/* Uit sections/casanuva-pdp-reviews.liquid gehaald. Draait met defer: na het parsen, dus de elementen
   die deze code opzoekt bestaan gegarandeerd. Alles zit in een IIFE,
   dus er lekt niets naar de global scope. */

(function(){
  var root=document.querySelector('.cnv-rev'); if(!root) return;
  var S='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3 6.9 7.5.6-5.7 4.9 1.8 7.3L12 17.8 5.4 21.7l1.8-7.3L1.5 9.5 9 8.9z"/></svg>';
  root.querySelectorAll('[data-fill]').forEach(function(row){
    var pct=parseFloat(row.getAttribute('data-fill'))||0,h='';
    for(var i=0;i<5;i++){var lo=i*20,hi=(i+1)*20,f=pct<=lo?0:pct>=hi?100:(pct-lo)/20*100;h+='<span class="star">'+S+'<span class="fill" style="width:'+f+'%">'+S+'</span></span>';}
    row.innerHTML=h;
  });
  var list=document.getElementById('cnvr-list'); if(!list) return;
  var reviews=[].slice.call(list.querySelectorAll('.review'));
  var tabs=root.querySelectorAll('.fchip'), moreBtn=document.getElementById('cnvr-more'), noMatch=document.getElementById('cnvr-nomatch');
  var filter='all', shown=5;
  function apply(){
    var visible=0, matched=0;
    reviews.forEach(function(r){
      var rate=r.getAttribute('data-rating'), gift=r.getAttribute('data-gift')==='true';
      var ok=filter==='all'||(filter==='gift'&&gift)||(filter==='critical'&&(+rate<=3))||rate===filter;
      if(ok){matched++; if(visible<shown){r.style.display='';visible++;} else {r.style.display='none';}} else {r.style.display='none';}
    });
    if(noMatch) noMatch.style.display=matched?'none':'block';
    if(moreBtn) moreBtn.style.display=matched>shown?'block':'none';
  }
  function setFilter(f){ filter=(filter===f&&f!=='all')?'all':f; shown=5; tabs.forEach(function(t){t.classList.toggle('on',t.getAttribute('data-filter')===filter);}); apply(); }
  tabs.forEach(function(t){ t.addEventListener('click',function(){ setFilter(t.getAttribute('data-filter')); }); });
  if(moreBtn) moreBtn.addEventListener('click',function(){ shown+=6; apply(); });
  apply();
})();
